import { ApiGateWay } from './../../ApiGateWay/ApiGateWay';
import { Config } from './../../config/config';
import Cookie from 'js-cookie';

const config = JSON.parse(Config);

export const RETAIL_EVACUATIONS = async (url, userId, month, year) => {
  const fetchedData = await ApiGateWay.Post(config['api'] + url, {
    userId: userId,
    month: month,
    year: year,
  })
    .then((response) => response.json())
    .then((response) => {
      if (
        response.errorMessage === 'Token Expired' ||
        response.errorMessage === 'Invalid Token:::JWT expired' ||
        response.errorMessage ===
          'Your session has expired. Please login again.'
      ) {
        Cookie.remove('currentUser');
        Cookie.remove('stores');
        Cookie.remove('storesAll');
        Cookie.remove('warehouses');

        localStorage.clear();
        sessionStorage.clear();
        alert('Your session has expired. Please login again.');
        return (window.location = '/');
      }

      let body = [];
      let stores = [];
      let colorCodes = [];
      let storeID = [];
      let evacuationData = [];
      let evacuationReports = [];
      let deadlineData = [];
      let statusData = [];
      let proxyjson = [];
      response.globalEvacuationReports
        .sort((a, b) => (a.storeName > b.storeName ? 1 : -1))
        .map((name, val) => {
          storeID.push(name.storeId);
          body.push([name.deadline, name.lastEvaDate, name.evacuationCount]);
          stores.push(name.storeName);
          name.lastEvaDate != 'Not done'
            ? colorCodes.push([0, 1, 0])
            : colorCodes.push([0, 2, 0]);
          evacuationData = [];
          deadlineData = [];
          statusData = [];
          name.evacuationInfos.map((val, ind) => {
            deadlineData.push(name.deadline);
            statusData.push(name.lastEvaDate);
            evacuationData.push([val.evaStatus, val.evaDate, val.evaCreatedBy]);
          });
          evacuationReports.push([deadlineData, statusData, evacuationData]);
        });
      return (proxyjson = {
        type: 'Evacuations',
        thead: [
          'Store Name',
          'Deadline',
          'Status',
          'No of evacuations done YTD',
        ],
        storeId: storeID,

        tbody: body,
        columns: ['Deadline', 'Status', 'No of evacuations done per year'],
        stores: stores,
        colorCodes: colorCodes,
        popUpDataGrid: evacuationReports,
        popUpDataGridHeaders: [
          'Evacuation Status',
          'Evacuation Date',
          'Evacuation Created By',
        ],
      });
    });
  return fetchedData;
};

export const RETAIL_STORE_EVACUATIONS = async (url, storeId, year) => {
  const fetchedData = await ApiGateWay.Get(
    config['api'] + url + '?storeId=' + storeId + '&year=' + year
  )
    .then((response) => response.json())
    .then((response) => {
      if (
        response.errorMessage === 'Token Expired' ||
        response.errorMessage === 'Invalid Token:::JWT expired' ||
        response.errorMessage ===
          'Your session has expired. Please login again.'
      ) {
        Cookie.remove('currentUser');
        Cookie.remove('stores');
        Cookie.remove('storesAll');
        Cookie.remove('warehouses');

        localStorage.clear();
        sessionStorage.clear();
        alert('Your session has expired. Please login again.');
        return (window.location = '/');
      }
      let body = [];
      let stores = [];
      let colorCodes = [];
      let evacuationnumber = [];
      let evacuationReports = [];
      let EvacuationData = [];
      let proxyjson = [];

      response.storeWiseEvacuationReports.map((name, val) => {
        body.push([
          name.targetDate,
          name.lastEvacuationDate,
          name.evacuationCount,
        ]);
        stores.push(name.month);
        name.lastEvacuationDate != 'Not done'
          ? colorCodes.push([0, 1, 1])
          : colorCodes.push([0, 2, 2]);
        evacuationnumber.push(name.evacuationCount);
        EvacuationData = [];
        name.evacuationInfos.map((val, index) => {
          EvacuationData.push([val.evaStatus, val.evaDate, val.evaCreatedBy]);
        });
        evacuationReports.push([
          name.targetDate,
          name.lastEvacuationDate,
          EvacuationData,
        ]);
      });

      return (proxyjson = {
        type: 'Evacuations',

        thead: ['Month', 'Target', 'Status', 'No of evacuations'],
        evacuationCount: evacuationnumber,
        tbody: body,
        columns: ['Deadline', 'Status', 'No of evacuations'],
        stores: stores,
        colorCodes: colorCodes,
        popUpDataGrid: evacuationReports,
        popUpDataGridHeaders: [
          'Evacuation Status',
          'Evacuation Date',
          'Evacuation Created By',
        ],
      });
    });
  return fetchedData;
};

export const LOGISTICS_EVACUATIONS = async (url, userId, month, year) => {
  const fetchedData = await ApiGateWay.Post(config['api'] + url, {
    userId: userId,
    month: month,
    year: year,
  })
    .then((response) => response.json())
    .then((response) => {
      if (
        response.errorMessage === 'Token Expired' ||
        response.errorMessage === 'Invalid Token:::JWT expired' ||
        response.errorMessage ===
          'Your session has expired. Please login again.'
      ) {
        Cookie.remove('currentUser');
        Cookie.remove('stores');
        Cookie.remove('storesAll');
        Cookie.remove('warehouses');

        localStorage.clear();
        sessionStorage.clear();
        alert('Your session has expired. Please login again.');
        return (window.location = '/');
      }
      let body = [];
      let stores = [];
      let colorCodes = [];
      let storeID = [];
      let evacuationData = [];
      let evacuationReports = [];
      let deadlineData = [];
      let statusData = [];
      let proxyjson = [];
      response.evacuationWareHouseInfos
        .sort((a, b) => (a.storeName > b.storeName ? 1 : -1))
        .map((name, val) => {
          storeID.push(name.storeId);
          body.push([name.deadLine, name.lastEvaDate, name.evacCount]);
          stores.push(name.storeName);
          name.lastEvaDate != 'Not done'
            ? colorCodes.push([0, 1, 1])
            : colorCodes.push([0, 2, 2]);
          evacuationData = [];
          deadlineData = [];
          statusData = [];
          name.evacuationInfos.map((val, ind) => {
            deadlineData.push(name.deadline);
            statusData.push(name.lastEvaDate);
            evacuationData.push([val.evaStatus, val.evaDate, val.evaCreatedBy]);
          });
          evacuationReports.push([deadlineData, statusData, evacuationData]);
        });
      return (proxyjson = {
        type: 'Evacuations',

        thead: [
          'Store Name',
          'Deadline',
          'Status',
          'No of evacuations done YTD',
        ],
        storeId: storeID,

        tbody: body,
        columns: ['Deadline', 'Status', 'No of evacuations done per year'],
        stores: stores,
        colorCodes: colorCodes,
        popUpDataGrid: evacuationReports,
        popUpDataGridHeaders: [
          'Evacuation Status',
          'Evacuation Date',
          'Evacuation Created By',
        ],
      });
    });
  return fetchedData;
};

export const LOGISTICS_STORE_EVACUATIONS = async (url, storeId, year) => {
  const fetchedData = await ApiGateWay.Get(
    config['api'] + url + '?storeId=' + storeId + '&year=' + year
  )
    .then((response) => response.json())
    .then((response) => {
      if (response.errorMessage === 'Token Expired') {
        Cookie.remove('currentUser');
        Cookie.remove('stores');
        Cookie.remove('storesAll');
        Cookie.remove('warehouses');

        localStorage.clear();
        sessionStorage.clear();
        alert('Your session has expired. Please login again.');
        return (window.location = '/');
      }
      let body = [];
      let stores = [];
      let colorCodes = [];
      let evacuationnumber = [];
      let evacuationReports = [];
      let EvacuationData = [];
      let proxyjson = [];

      response.storeWiseEvacuationReports.map((name, val) => {
        body.push([
          name.targetDate,
          name.lastEvacuationDate,
          name.evacuationCount,
        ]);
        stores.push(name.month);
        name.lastEvacuationDate != 'Not done'
          ? colorCodes.push([0, 1, 1])
          : colorCodes.push([0, 2, 2]);
        evacuationnumber.push(name.evacuationCount);
        EvacuationData = [];
        name.evacuationInfos.map((val, index) => {
          EvacuationData.push([val.evaStatus, val.evaDate, val.evaCreatedBy]);
        });
        evacuationReports.push([
          name.targetDate,
          name.lastEvacuationDate,
          EvacuationData,
        ]);
      });

      return (proxyjson = {
        type: 'Evacuations',

        thead: ['Month', 'Target', 'Status', 'No of evacuations'],
        evacuationCount: evacuationnumber,
        tbody: body,
        columns: ['Deadline', 'Status', 'No of evacuations'],
        stores: stores,
        colorCodes: colorCodes,
        popUpDataGrid: evacuationReports,
        popUpDataGridHeaders: [
          'Evacuation Status',
          'Evacuation Date',
          'Evacuation Created By',
        ],
      });
    });
  return fetchedData;
};
